export interface FiltersAndTools {
  appliedFilters: string;
  editedCount: number;
  gpDelta: number;
  gpDifferenceNegative: number;
  gpDifferencePositive: number;
  isApplyPriceBandingOn: boolean;
  isEditedItemsOn: boolean;
  isGpDifferenceNegativeOn: boolean;
  isGpDifferencePositiveOn: boolean;
  isToggleAccordionSubHeaderHidden: boolean;
  isToggleAccordionSubHeaderOn: boolean;
  newItemCount: number;
  showSubmissionPreview: boolean;
  total: number;
  totalShowing: number;
}

export const filtersAndToolsDefault: FiltersAndTools = {
  appliedFilters: 'None',
  isApplyPriceBandingOn: false,
  gpDelta: 0,
  editedCount: 0,
  isEditedItemsOn: false,
  gpDifferencePositive: 0,
  isGpDifferencePositiveOn: true,
  gpDifferenceNegative: 0,
  isGpDifferenceNegativeOn: true,
  newItemCount: 0,
  total: 0,
  totalShowing: 0,
  isToggleAccordionSubHeaderOn: false,
  isToggleAccordionSubHeaderHidden: false,
  showSubmissionPreview: false,
};
